import StorageService from '../services/StorageService';
import store from '../store';
import { isMobile } from './BrowserHelpers';
import { userHasAnyOfPermissions, userHasAllOfPermissions } from './UserHelpers';
import { getLoggedInUser } from '../selectors/userSelectors';
import {
  THREAD_VIEW,
  CONVERSATION_CONTACT_MOBILE,
  CONTACT_EDIT,
  CONTACT_DELETE,
  TEAM_THREAD_VIEW,
  TEAM_CONVERSATION_EDIT,
  CONVERSATION_TEAM_MOBILE,
} from '../constants/UserPermissionsConstants';

// This is copied from uiSelectors and used in Action files since selectors will not work there.  Keeping the
// selector as well since it should be more performant when using from components.
export function getTotalUnreadCount() { // eslint-disable-line
  const currentState = store.getState();
  const secureChannels = currentState.secure.channels;
  const secureChannelIds = currentState.secure.channelIds;
  const { inboxSections } = currentState.ui;
  let totalCount = 0;
  const isPatientExperience = StorageService.readEntry('patientExperience');
  const currentUser = getLoggedInUser(currentState);

  if (isPatientExperience) { // for end users
    totalCount = secureChannelIds.reduce(
      (accumulator, currentValue) => accumulator + secureChannels[currentValue].unread,
      0,
    );
  } else { // for members
    const contactsPermissions = isMobile() ? (userHasAllOfPermissions([THREAD_VIEW, CONVERSATION_CONTACT_MOBILE]) ||
      userHasAllOfPermissions([CONTACT_EDIT, CONVERSATION_CONTACT_MOBILE]) ||
      userHasAllOfPermissions([CONTACT_DELETE, CONVERSATION_CONTACT_MOBILE])) :
      userHasAnyOfPermissions([THREAD_VIEW]);

    const teamPermissions = isMobile() ? (userHasAllOfPermissions([TEAM_THREAD_VIEW, CONVERSATION_TEAM_MOBILE]) ||
      userHasAllOfPermissions([TEAM_CONVERSATION_EDIT, CONVERSATION_TEAM_MOBILE])) :
      userHasAnyOfPermissions([TEAM_THREAD_VIEW]);

    let sectionInbox = inboxSections.inbox;
    let sectionChat = inboxSections.chat;

    if (currentUser && !currentUser.isCCr && currentUser.preferences.isBadgeCountUpdatedOnNotification) {
      // Get current user's notification preferences
      const { inbox, chat, inboxAndChat } = currentUser.preferences;
      const inboxPreferences = inbox.concat(inboxAndChat);
      const chatPreferences = chat.concat(inboxAndChat);

      // remove inboxes disabled in user's notification preferences from total count
      sectionInbox = inboxSections.inbox.filter((section) => {
        const match = inboxPreferences.find(pref => pref.displayName === section.displayName);
        return isMobile() ? match.mobile : match.desktop;
      });

      sectionChat = inboxSections.chat.filter((section) => {
        const match = chatPreferences.find(pref => pref.displayName === section.displayName);
        return isMobile() ? match.mobile : match.desktop;
      });
    }

    const inboxCount = contactsPermissions && inboxSections.inbox && sectionInbox.reduce(
      (accumulator, currentValue) => accumulator + (currentValue.type === 'mentions' ? currentValue.unreadMentionIds.length : currentValue.unreadUserIds.length),
      0,
    );

    const chatCount = teamPermissions && inboxSections.chat && sectionChat.reduce(
      // eslint-disable-next-line max-len
      (accumulator, currentValue) => accumulator + (currentValue.unreadUserIds?.length ?? 0) + (currentValue.unreadGroupIds?.length ?? 0),
      0,
    );
    totalCount = inboxCount + chatCount;
  }
  return totalCount > 99999 ? 99999 : totalCount;
}

export function isBadgeCountVisible(section, group) {
  const currentState = store.getState();
  const currentUser = getLoggedInUser(currentState);
  const { isBadgeCountUpdatedOnNotification, inbox, chat, inboxAndChat } = currentUser.preferences;

  const inboxPreferences = inbox.map(pref => ({ ...pref, section: 'inbox' }));
  const chatPreferences = chat.map(pref => ({ ...pref, section: 'chat' }));
  const inboxAndChatPreferences = inboxAndChat.map(pref => ({ ...pref, section: 'inboxAndChat' }));

  const notificationPreferences = inboxPreferences.concat(chatPreferences, inboxAndChatPreferences);

  if (isBadgeCountUpdatedOnNotification) {
    const pref = notificationPreferences.find(p => p.displayName === group.displayName && (p.section === section || p.section === 'inboxAndChat'));

    return isMobile() ? pref.mobile : pref.desktop;
  } else {
    return true;
  }
}
